const BaseServiceURL = "https://pl2wuycvih.execute-api.sa-east-1.amazonaws.com";
const CowRegistersServiceURL = BaseServiceURL + "/cowregisters/";
const ClientRegistersServiceURL = BaseServiceURL + "/clients/";
const ClientsSummaryServiceURL = BaseServiceURL + "/clients/summary";
export {CowRegistersServiceURL, ClientRegistersServiceURL, ClientsSummaryServiceURL}